import React from 'react'
import { Icon, Modal, Button } from 'semantic-ui-react';
import { Form, Dropdown } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import { singleLineText } from '../../../../common/RegexValidation';
import { source } from 'react-aim';
import defaultImage from '../../../../../images/logo/logo-128.png'
import setCategoryImage from '../../../../../helpers/setCategoryImage'
@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Categories Card');
    }
})

class AccessControlUpdateModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scope: this.props.scope,
            autoFocus: false,
            KBCategories: null,
            k: null,
            c: null,
            s: null,
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.type !== newProps.type) {
            this.setKnowledgeBank()
        }

    }

    componentWillMount() {
        this.setKnowledgeBank()
    }

    setKnowledgeBank() {
        let pr = this.props.baseCategoriesArr &&
            this.props.baseCategoriesArr.length !== 0 ?
            this.props.baseCategoriesArr : [];
        pr.forEach(p => {
            p.key = p._id
            // delete p.label;
            p.text = p.name;
            delete p.children
            p.value = p._id;
            p.image = setCategoryImage(p.image, this.props.selectedAccount)
        })
        this.setState({
            PrivateCategory: pr
        })

        let pb = this.props.publicCategoryList &&
            this.props.publicCategoryList.length !== 0 ?
            this.props.publicCategoryList : [];
        pb.forEach(p => {
            p.key = p._id
            // delete p.label;
            p.text = p.name;
            delete p.children
            p.value = p._id;
        })

        this.setState({
            PublicCategory: pb
        })
    }

    handleChangeKB = (e, data) => {
        let KB = data.options.filter((kb, i) => { return kb._id.toString() === data.value.toString() });
        KB[0].nodes && KB[0].nodes.forEach(cat => {
            cat.key = cat._id
            // delete cat.label;
            cat.text = cat.name;
            delete cat.children
            cat.value = cat._id;
        })
        this.setState({
            k: data.value,
            c: null,
            s: null,
            otherSubCategory: false,
            KBCategories: KB[0].nodes ? KB[0].nodes : [],
            KBSubCategories: null
        })
    }

    handleChangeCategory = (e, data) => {
        let CAT = data.options.filter((cat, i) => { return cat._id.toString() === data.value.toString() });
        if (!CAT[0].nodes) {
            CAT[0].nodes = [];
        }
        // let isOtherAvailable = CAT[0].nodes.filter(f => f.name === "Others")

        // if (isOtherAvailable && isOtherAvailable.length === 0) {
        //     CAT[0].nodes.push({
        //         _id: "Others",
        //         name: "Others",
        //         className: "withLabel"
        //     })
        // }

        CAT[0] && CAT[0].nodes && CAT[0].nodes.forEach(subcat => {
            subcat.key = subcat._id
            // delete subcat.label;
            subcat.text = subcat.name;
            delete subcat.children
            subcat.value = subcat._id;
        })
        this.setState({
            c: data.value,
            s: null,
            otherSubCategory: false,
            KBSubCategories: CAT[0] ? CAT[0].nodes : []
        })
    }

    handleChangeSubCategory = (e, data) => {
        this.setState({
            otherSubCategory: false,
            s: data.value,
            autoFocus: false
        })
        // if (data.value === "Others") {
        //     this.setState({
        //         otherSubCategory: true,
        //         s: '',
        //         autoFocus: true
        //     })
        // } else {
        //     this.setState({
        //         otherSubCategory: false,
        //         s: data.value,
        //         autoFocus: false
        //     })
        // }
    }

    handleChangeSubCategoryText = (e, data) => {
        this.setState({
            s: data.value
        })
    }

    // clearSubCategory = () => {
    //     this.setState({
    //         otherSubCategory: false,
    //         s: ''
    //     })
    // }

    componentWillReceiveProps(newProps) {
        if (this.props.scope !== this.state.scope) {
            this.setState({ scope: this.props.scope })
        }
    }

    clearState = () => {
        this.setState({
            k: null,
            c: null,
            s: null,
            otherSubCategory: false,
            autoFocus: false,
            scope: this.state.scope,
        })
    }

    update = () => {
        this.clearState()
        this.props.updateCategory(this.state);
    }

    close = () => {
        this.clearState()
        this.props.handleModalKB(false);
    }


    render() {

        const errorLabel = <div className="customErrorLabel" />;

        let setKb = this.props.type === "category" ?
            this.props.scope === "Private" ? this.state.PrivateCategory :
                this.state.PublicCategory :
            this.props.scope === "Private" ? this.state.PublicCategory :
                this.state.PrivateCategory
        const KnowledgeBankDropdown = <React.Fragment>
            <Dropdown
                className="noLabel"
                name="singleSelectWithDefaultValue"
                value={this.state.k}
                placeholder="Select Knowledge Bank"
                fluid
                selection
                required
                validationErrors={{
                    isDefaultRequiredValue: 'You need to select a Knowledge Bank',
                }}
                errorLabel={errorLabel}
                options={setKb}
                onChange={(e, value) => { this.handleChangeKB(e, value) }}
            />
            <span>
                {this.state.KBCategories && this.state.KBCategories.length === 0 ?
                    <span className="clr-red">No Category</span> :
                    null}
            </span>
        </React.Fragment>

        let CategoryDropdown = <React.Fragment>
            <Dropdown
                className="noLabel"
                name="singleSelectWithDefaultValue"
                value={this.state.c}
                disabled={!this.state.k || this.state.KBCategories && this.state.KBCategories.length === 0}
                placeholder="Select Category"
                fluid
                selection
                required
                validationErrors={{
                    isDefaultRequiredValue: 'You need to select a Category',
                }}
                errorLabel={errorLabel}
                options={this.state.KBCategories}
                onChange={(e, value) => { this.handleChangeCategory(e, value) }}
            />
        </React.Fragment>

        let SubCategoryDropdown = <React.Fragment>
            {(this.state.KBSubCategories && this.state.KBSubCategories.length === 0)  ?
                <p style={{marginTop: "10px", color: "red"}}>No Sub Category available</p>
                :
                <Dropdown
                    className="noLabel"
                    name="singleSelectWithDefaultValue"
                    placeholder="Select Sub Category"
                    value={this.state.s}
                    disabled={!this.state.c}
                    fluid
                    selection
                    required
                    validationErrors={{
                        isDefaultRequiredValue: 'You need to select a Sub Category',
                    }}
                    errorLabel={errorLabel}
                    options={this.state.KBSubCategories}
                    onChange={(e, value) => { this.handleChangeSubCategory(e, value) }}
                />}
        </React.Fragment>

        let AccessControl = <Form.Field >
            <Form.Radio
                name='scope'
                label='Workspace Library'
                value='Private'
                checked={this.state.scope === 'Private'}
                onChange={this.handleChange}
                disabled={this.props.scope === "Private"}
            />
            <div className="f_10" style={{ margin: '0px 0 10px 22px' }}><span style={{ textTransform: "capitalize" }} >{this.props.page}</span> will appear under Workspace Library after it is published. All workspace level users can view this {this.props.page}.</div>
            <Form.Radio
                name='scope'
                label='Public Library'
                value='Public'
                checked={this.state.scope === 'Public'}
                onChange={this.handleChange}
                disabled={this.props.scope === "Public"}
            />
            <div className="f_10" style={{ margin: '0px 0 10px 22px' }}><span style={{ textTransform: "capitalize" }} >{this.props.page}</span> will appear under Workspace Library after it is published. All workspace level users can view this {this.props.page}.</div>
        </Form.Field>


        return (
            <div>
                <Modal
                    className="basicModal "
                    open={this.props.open}
                    size="tiny"
                    onClose={this.close}
                    closeOnEscape={true}
                    closeOnDimmerClick={false}
                    closeIcon>

                    <Modal.Header>

                        {this.props.type === "scope" ?
                            <span>Change to {this.props.scope === "Private" ? "Public" : "Private"} Library</span> :
                            <span>Update Category</span>
                        }</Modal.Header>
                    <Modal.Content >

                        <Form
                            className="formcyForm"
                        >
                            <div style={{ margin: "0 0 5px 0px" }} > Knowledge Bank </div>
                            {KnowledgeBankDropdown}

                            <div style={{ margin: "0 0 5px 0px" }}> Category </div>
                            {CategoryDropdown}

                            <div style={{ margin: "0 0 5px 0px" }}> Sub Category </div>
                            {SubCategoryDropdown}


                        </Form>
                    </Modal.Content>
                    <Modal.Actions className="actionInFormcy">
                        <Button
                            className="button-submit float-right"
                            type="submit"
                            onClick={this.update}
                            disabled={!this.state.s}>
                            Update
                        </Button>
                        <Button
                            className="button-cancel"
                            type="button"
                            onClick={this.close}>
                            Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>
            </div >
        )
    }
}

export default AccessControlUpdateModal